import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";
import { isLiv } from "^/utils/isLiv";

function filenameToType(filename) {
  return filename.split(".").pop();
}

function Breadcrumb({
  objProps,
  className,
  classNameProps,
  ancestor,
  hasMedia,
}) {
  if (objProps && objProps.isBinary()) {
    return (
      <div className="breadcrumb-item active">
        {I18n.t("DocumentType", {
          type: filenameToType(objProps.get("blob").filename().toUpperCase()),
        })}
      </div>
    );
  }

  const obj = objProps || Scrivito.currentPage();
  const anc = ancestor || obj.ancestors();
  const items = anc.filter(
    (item) =>
      item &&
      item.objClass() !== "Root" &&
      item.get("hideInNavigation") !== "yes"
  );

  const classNames = classNameProps
    ? `breadcrumb ${classNameProps}`
    : "breadcrumb py-3 m-0";

  const classNameWithMedia = hasMedia
    ? `${classNames} col-12 col-md-7 offset-md-5`
    : classNames;

  return (
    <nav
      aria-label="breadcrumb row"
      className={`breadcrumb-wrapper ${className}`}
    >
      {!isLiv(obj) && (
        <ol
          className={classNameWithMedia}
          itemScope
          itemType="http://schema.org/BreadcrumbList"
        >
          {items.map((item, i) => (
            <li
              className="breadcrumb-item"
              key={item.id()}
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
            >
              {item.get("isNavigationPage") === "yes" ? (
                <>
                  <Scrivito.LinkTag
                    to={item}
                    itemProp="item"
                    title={item.get("title")}
                    name={item.get("title")}
                  >
                    <span itemProp="name">{item.get("title")}</span>
                  </Scrivito.LinkTag>
                  <meta itemProp="position" content={i} />
                </>
              ) : (
                <>
                  <Scrivito.LinkTag
                    to={item}
                    itemProp="item"
                    title={item.get("title")}
                    name={item.get("title")}
                  >
                    <span itemProp="name">{item.get("title")}</span>
                  </Scrivito.LinkTag>
                  <meta itemProp="position" content={i} />
                </>
              )}
            </li>
          ))}
          <li
            className="breadcrumb-item active"
            aria-current="page"
            itemProp="itemListElement"
            itemScope
            itemType="http://schema.org/ListItem"
            title={obj.get("title")}
            name={obj.get("title")}
          >
            <span itemProp="name">{obj.get("title")}</span>
            <meta itemProp="position" content={items.length} />
          </li>
        </ol>
      )}
    </nav>
  );
}

export default Scrivito.connect(Breadcrumb);
